import type { EditorPlugin } from '../../../types/aha-editor';
import BoldMarkPlugin from './BoldMarkPlugin';
import BoldMarkMarkdownPlugin from './BoldMarkMarkdownPlugin';

const BoldPlugin: EditorPlugin[] = [BoldMarkPlugin, BoldMarkMarkdownPlugin];
export default BoldPlugin;
